<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.unit.dialog.title' | translate"
		id="unit-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div
					[sklValidationSource]="viewValidation"
					class="grid">
					<div class="col-1">
						<ins-checkbox
							id="unit-dialog-default"
							[(ngModel)]="viewModel.bo.model.default"
							[label]="'scenes.configuration.shared.unit.dialog.form.default.label' | translate "
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.unit.dialog.form.symbol.label' | translate">
							<ins-input
								id="unit-dialog-symbol"
								[skl-focus-by]
								[(ngModel)]="viewModel.bo.model.symbol"
								[placeholder]="'scenes.configuration.shared.unit.dialog.form.symbol.placeholder' | translate"
								[sklValidate]="getValidationKey('symbol')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.unit.dialog.form.name.label' | translate">
							<ins-input
								id="unit-dialog-name"
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.unit.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="unit-dialog-cancel-button"
			(click)="onCancel()">
			{{'scenes.configuration.shared.base.dialog.buttons.cancel' | translate}}
		</skl-button>
		<skl-button
			id="unit-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{'scenes.configuration.shared.base.dialog.buttons.save' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>